import { Location } from '@angular/common';
import { Component, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, NavigationEnd, Event } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  idleState = "NOT_STARTED";
  countdown?: number | undefined | null = null;
  lastPing?: Date | undefined | null = null;

  constructor(
    private idle: Idle,
    private cd: ChangeDetectorRef,
    private cookieService: CookieService,
    private snackBar: MatSnackBar,
    private router: Router,
    private Location: Location,
    private dialogRef: MatDialog
  ) {
    this.idle.setIdle(60); // how long can they be inactive before considered idle, in seconds
    this.idle.setTimeout(1740); // how long can they be idle before considered timed out, in seconds
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active

    this.router.events.subscribe((event: Event) => {

      if (event instanceof NavigationEnd) {

        if (event.url !== '/authentication/login') {

          // do something when the user becomes idle
          this.idle.onIdleStart.subscribe(() => {

            this.idleState = "IDLE";
            this.showSnack()
          });
          // do something when the user is no longer idle
          this.idle.onIdleEnd.subscribe(() => {
            this.idleState = "NOT_IDLE";
            this.countdown = null;
            this.cd.detectChanges(); // how do i avoid this kludge?
          });
          // do something when the user has timed out
          this.idle.onTimeout.subscribe(() => this.idleState = "TIMED_OUT");
          // do something as the timeout countdown does its thing
          this.idle.onTimeoutWarning.subscribe(seconds => {
            this.countdown = seconds

            if (this.countdown == 1) {
              this.dialogRef.closeAll();
              this.router.navigate(['/authentication/login']);
              this.snackBar.dismiss();
            }
          });

        }
      }


    });

  }

  reset() {
    this.idle.watch();
    this.idleState = "NOT_IDLE";
    this.countdown = null;
    this.lastPing = null;
  }

  showSnack() {
    this.snackBar.open('¿Sigues ahi?', 'Sí', {
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  ngOnInit(): void {
    this.reset();
  }

}
